module.exports = __webpack_public_path__ + "static/number-1-9fe015dc7f10b173ed61c9578b2396f9.webp";